var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MatchMedia',{attrs:{"query":_vm.$options.queries.portable},scopedSlots:_vm._u([{key:"default",fn:function({ matches }){return [(matches)?_c('OffCanvasMenuContent',{attrs:{"menu-data":_vm.menuData}}):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }